<div class="relative">
  <!-- Timeline items -->
  <div class="flex flex-col gap-y-6">
    @for (item of auditLogs(); track $index; let last = $last) {
      <div class="relative flex gap-4">
        <!-- Timeline line for each item -->
        @if (!last) {
          <div
            class="bg-border absolute top-8 left-4 h-full w-0.5 -translate-x-1/2"
          ></div>
        }

        <div class="flex flex-1 flex-col">
          <!-- Timeline marker and header (clickable area) -->
          <div
            class="relative z-10 flex gap-4"
            [class.cursor-pointer]="isCollapsible()"
            (click)="toggleItemExpansion(item.timestamp, $event)"
          >
            <div class="flex-none">
              <span
                class="flex h-8 w-8 items-center justify-center rounded-full text-white"
                [class]="getIconColor(item.action)"
              >
                <hlm-icon size="sm" [name]="getIconName(item.action)" />
              </span>
            </div>

            <div
              class="flex flex-1 justify-between gap-2"
              [ngClass]="{
                'items-baseline': inPdf(),
                'items-center': !inPdf()
              }"
            >
              <div
                class="flex gap-1"
                [ngClass]="{
                  'flex-col items-baseline': inPdf(),
                  'items-center': !inPdf()
                }"
              >
                <p class="font-medium" [class.text-sm]="inPdf()">
                  {{ getTimelineContent(item) }}
                </p>
                <p class="text-muted-foreground" [class.text-sm]="inPdf()">
                  by {{ item.actor || 'N/A' }}
                </p>

                @if (isCollapsible()) {
                  <hlm-icon
                    class="text-muted-foreground"
                    size="sm"
                    [name]="
                      isItemExpanded(item.timestamp)
                        ? 'lucideChevronDown'
                        : 'lucideChevronRight'
                    "
                  />
                }
              </div>
              <div class="flex items-center gap-2">
                <small class="text-muted-foreground text-sm whitespace-nowrap">
                  {{ item.timestamp | date: 'medium' }}
                </small>
              </div>
            </div>
          </div>

          <!-- Timeline content (non-clickable area) -->
          <div
            class="overflow-hidden"
            [@expandCollapse]="
              isItemExpanded(item.timestamp) ? 'expanded' : 'collapsed'
            "
          >
            @if (item.action === 'update' && item.details.length) {
              <div class="mt-2 flex flex-col gap-y-1 pl-12">
                @for (detail of item.details; track $index) {
                  <div class="text-sm">
                    <span class="text-primary font-medium"
                      >{{ detail.field }}
                    </span>
                    @if (isJsonString(detail.changes[0])) {
                      @if (!inPdf()) {
                        <button
                          hlmBtn
                          class="ml-2"
                          size="xs"
                          variant="secondary"
                          (click)="
                            toggleChangeExpansion(
                              generateChangeId(
                                item.timestamp,
                                $index,
                                detail.field
                              )
                            )
                          "
                        >
                          {{
                            isChangeExpanded(
                              generateChangeId(
                                item.timestamp,
                                $index,
                                detail.field
                              )
                            )
                              ? 'Hide changes'
                              : 'View changes'
                          }}
                          <hlm-icon
                            size="sm"
                            [name]="
                              isChangeExpanded(
                                generateChangeId(
                                  item.timestamp,
                                  $index,
                                  detail.field
                                )
                              )
                                ? 'lucideChevronUp'
                                : 'lucideChevronDown'
                            "
                          />
                        </button>
                      }
                      <div
                        class="overflow-hidden"
                        [@expandCollapseChanges]="
                          isChangeExpanded(
                            generateChangeId(
                              item.timestamp,
                              $index,
                              detail.field
                            )
                          )
                            ? 'expanded'
                            : 'collapsed'
                        "
                      >
                        <div class="mt-2 flex flex-col gap-y-2">
                          @for (
                            diff of getChangeDifferences(
                              detail.changes[0],
                              detail.changes[1]
                            );
                            track diff.key
                          ) {
                            <div class="bg-muted/30 rounded-md px-2">
                              <div class="font-medium">{{ diff.key }}:</div>
                              <div class="flex items-center gap-2">
                                <span class="font-medium text-red-800">{{
                                  diff.old === null ? 'null' : diff.old
                                }}</span>
                                <hlm-icon
                                  class="text-muted-foreground"
                                  name="lucideArrowRight"
                                  size="sm"
                                />
                                <span class="font-medium text-green-800">{{
                                  diff.new === null ? 'null' : diff.new
                                }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      changed from
                      <span class="font-medium text-red-800">{{
                        detail.changes[0] || 'N/A'
                      }}</span>
                      to
                      <span class="font-medium text-green-800">{{
                        detail.changes[1] || 'N/A'
                      }}</span>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
